export const isWebView = (ua?: string): boolean => {
  const w = typeof window !== 'undefined' ? window : undefined;
  const nav = typeof navigator !== 'undefined' ? navigator : undefined;
  const userAgent = ua ?? nav?.userAgent ?? '';

  // 1) React Native WebView (sinal confiável)
  if (w && (w as any).ReactNativeWebView) return true;

  // 1.5) Fallback: localStorage.platform injetado via injectedJavaScriptBeforeContentLoaded
  // antes de qualquer JS da página — só existe quando rodando no app nativo
  try {
    const nativePlatform = localStorage.getItem('platform');
    if (nativePlatform === 'ios' || nativePlatform === 'android') return true;
  } catch (_) {}

  // 2) PWA instalado ≠ webview
  const isPwaStandalone =
    !!(
      w &&
      w.matchMedia &&
      w.matchMedia('(display-mode: standalone)').matches
    ) || !!(nav && (nav as any).standalone === true);
  if (isPwaStandalone) return false;

  // 3) In-app browsers (Instagram, FB, Google app, etc.) → forçar NÃO-webview
  const isInApp =
    /(FBAN|FBAV|Instagram|Line|Twitter|Snapchat|Pinterest|GSA|DuckDuckGo)/i.test(
      userAgent
    );
  if (isInApp) return false;

  // 4) Android WebView (UA costuma ter "; wv" ou "Version/x.y")
  const isAndroid = /Android/i.test(userAgent);
  if (
    isAndroid &&
    (/\bwv\b/.test(userAgent) || /Version\/\d+\.\d+/.test(userAgent))
  ) {
    return true;
  }

  // 5) iOS WKWebView (heurística: iOS sem "Safari" no UA)
  const isiOS = /iPhone|iPad|iPod/i.test(userAgent);
  const hasSafariToken = /Safari/i.test(userAgent);
  if (isiOS && !hasSafariToken) return true;

  return false;
};

export const redirectUri = (brandName: string) => {
  return `${window.location.origin}/redir?loginBrand=${brandName}${
    isWebView() ? '&webView=true' : ''
  }`;
};

export const isAppleDevice = (): boolean => {
  if (typeof navigator === 'undefined') return false;

  const ua = navigator.userAgent.toLowerCase();

  const isiOS = /iphone|ipad|ipod/.test(ua);
  const isMacOS = /macintosh|mac os x/.test(ua);

  return isiOS || isMacOS;
};
